import React from 'react'

class IconPhone extends React.Component {
  render() {
    return (
      <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <title>Phone Icon</title>
        <path d="M19.82,16.32c-.07-.24-.62-.48-.84-.59-.64-.36-1.29-.71-1.91-1.07-.29-.18-.65-.52-1-.52-.68,0-1.67,2-2.27,2a2.43,2.43,0,0,1-1-.43,11.18,11.18,0,0,1-4.57-4.57,2.43,2.43,0,0,1-.43-1c0-.6,2-1.59,2-2.27,0-.35-.34-.71-.52-1C9,6.31,8.63,5.66,8.27,5c-.11-.22-.35-.77-.59-.84a.49.49,0,0,0-.23,0,4.79,4.79,0,0,0-1.55.35A2.93,2.93,0,0,0,4.71,5.85a4.25,4.25,0,0,0-.57,2.08,8.77,8.77,0,0,0,.77,2.92,10.58,10.58,0,0,0,.93,2,18.75,18.75,0,0,0,5.36,5.36,10.58,10.58,0,0,0,2,.93,8.77,8.77,0,0,0,2.92.77,4.25,4.25,0,0,0,2.08-.57,2.93,2.93,0,0,0,1.36-1.19,4.79,4.79,0,0,0,.35-1.55A.49.49,0,0,0,19.82,16.32Z"/>
      </svg>
    )
  }
}

export default IconPhone;



// WEBPACK FOOTER //
// ./src/components/icons/phone/index.js